import { render, staticRenderFns } from "./DescriptionList.vue?vue&type=template&id=745c64a4&scoped=true"
import script from "./DescriptionList.vue?vue&type=script&lang=js"
export * from "./DescriptionList.vue?vue&type=script&lang=js"
import style0 from "./DescriptionList.vue?vue&type=style&index=0&id=745c64a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c64a4",
  null
  
)

export default component.exports